// Will set state in Redux when consumer unmounts. Saved state can be selected and
// used to initialize component state using the selectSavedViewState selector with
// the corresponding ViewID.
import { saveViewState } from '@actions/ui';
import { AnyViewState, ViewID } from '@reducers/ui/viewRestoration';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

export const useSaveViewState = (view: ViewID, state: AnyViewState, deps?: any[]) => {
  const dispatch = useDispatch();
  const stateRef = useRef(state);

  useEffect(() => {
    stateRef.current = state;
  }, deps || []);

  useEffect(
    () => () => {
      dispatch(saveViewState(view, stateRef.current));
    },
    [],
  );
};
